/**
 * Purpose: Friendly empty placeholder for modules with no data; owner-action slot.
 * Inputs: icon (node or emoji string), title, message, action (node, e.g. "Add first product").
 * Outputs: centered block; renders nothing hostile — visitors see it only when a module chose to show it.
 */
import React from 'react';

const EmptyState = ({ icon = null, title, message = null, action = null, className = '' }) => (
  <div className={`flex flex-col items-center justify-center px-4 py-10 text-center ${className}`}>
    {icon && (
      <div className="mb-3 text-3xl text-gray-300 dark:text-gray-600 [&>svg]:h-10 [&>svg]:w-10" aria-hidden>
        {icon}
      </div>
    )}
    {title && <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">{title}</p>}
    {message && <p className="mt-1 max-w-sm text-sm text-gray-500 dark:text-gray-400">{message}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;
